import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.dispatchEvent(new Event('modal-dismiss', { bubbles: true }))
  }
}